import TestimonialSlider from "../Components/TestimonialSlider ";
import Gallery from "../Components/Gallery";
import { Link } from "react-router-dom";
import Countdown from "../Components/Countdown";
import EventSwitcher from "../Components/EventSwitcher";
import EventFeatures from "../Components/EventFeatures";
import RoleTabs from "../Components/RoleTabs";
import LivePulse from "../Components/LivePulse";
import DirectionSection from "../Components/DirectionSection";
import FaqSection from "../Components/FaqSection";
import SchedulesSection from "../Components/SchedulesSection";
// import TicketSection from "../Components/TicketSection";
import LetsDoIt from "../Components/LetsDoIt";
// import Speakersection from "../Components/Speakersection";
import { getBrochure } from "../api/brochure";
import { useEffect, useState } from "react";
import TrustedPartners from "../Components/TrustedPartners";
import FloorPlanSection from "../Components/FloorPlanSection";
import MediaPartners from "../Components/MediaPartners";
import SponsorPartners from "../Components/SponsorPartners";
import Speakersection from "../Components/Speakersection";
import EventPartners from "../Components/EventPartners";
import { withPublicUrl } from "../api/config";
import {
  EVENT_DATES,
  EVENT_LOCATION,
} from "../constants/eventDetails";
// import PromoPopup from "../Components/PromoPopup";
function Home() {
  const [brochure, setBrochure] = useState([]);

  useEffect(() => {
    getSocialList();
  }, []);

  const getSocialList = () => {
    getBrochure()
      .then((res) => {
        setBrochure(res?.data?.topics);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  return (
    <div style={{ overflowX: "hidden" }}>
      {/* <PromoPopup /> */}

      {/*-- Hero Video Section --*/}
      <section
        className="position-relative overflow-hidden"
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          background: "#0A0A1A",
        }}
      >
        {/* Video Background */}
        <div style={{ position: "absolute", inset: 0, zIndex: 0 }}>
          <video
            autoPlay
            muted
            loop
            playsInline
            onLoadedData={(e) => {
              e.target.style.opacity = 0.5;
            }}
            style={{
              position: "absolute",
              inset: 0,
              width: "100%",
              height: "100%",
              objectFit: "cover",
              opacity: 0,
              transition: "opacity 1.5s ease",
            }}
          >
            <source src={withPublicUrl("/videos/hero-bg.mp4")} type="video/mp4" />
          </video>
          {/* Gradient Overlay */}
          <div
            style={{
              position: "absolute",
              inset: 0,
              background:
                "linear-gradient(135deg, rgba(140,20,80,0.4) 0%, rgba(60,10,60,0.5) 40%, rgba(10,10,26,0.97) 100%)",
            }}
          />
        </div>

        {/* Floating Orbs */}
        <div
          style={{
            position: "absolute",
            inset: 0,
            zIndex: 1,
            pointerEvents: "none",
          }}
        >
          <div className="hero-orb hero-orb-1" />
          <div className="hero-orb hero-orb-2" />
        </div>

        {/* Content */}
        <div
          className="container position-relative"
          style={{ zIndex: 10, paddingTop: "140px", paddingBottom: "80px" }}
        >
          <div className="row align-items-center g-5">
            {/* Left — Text */}
            <div className="col-lg-7">
              <div className="mb-4" data-aos="fade-up" data-aos-delay="100">
                <span className="hero-badge">
                  <span className="hero-badge-dot" />
                  Venue: {EVENT_LOCATION}
                </span>
              </div>

              <div data-aos="fade-up" data-aos-delay="200">
                <h1
                  className="text-white mb-0"
                  style={{
                    fontSize: "clamp(52px, 8vw, 96px)",
                    lineHeight: 0.95,
                    letterSpacing: "-0.02em",
                    fontWeight: 700,
                  }}
                >
                  <span className="d-block">PROFIN</span>
                  <span className="d-block gradient-text">EXPO</span>
                  <span
                    className="d-block"
                    style={{
                      fontSize: "clamp(28px, 4vw, 50px)",
                      color: "#94a3b8",
                      fontWeight: 600,
                      marginTop: "8px",
                    }}
                  >
                    BANGKOK 2026
                  </span>
                </h1>
              </div>

              <p
                className="mt-4 mb-5"
                style={{
                  color: "#9CA3AF",
                  fontSize: "1.1rem",
                  lineHeight: 1.7,
                  maxWidth: "520px",
                }}
                data-aos="fade-up"
                data-aos-delay="300"
              >
                Where Global Finance, Trading &{" "}
                <span style={{ color: "#E91E8C", fontWeight: 700 }}>
                  Innovation
                </span>{" "}
                Meet. Join 5,000+ traders & investors at Southeast Asia's premier
                financial expo.
              </p>

              <div
                className="d-flex flex-wrap gap-3"
                data-aos="fade-up"
                data-aos-delay="400"
              >
                <Link to="/Sponsers" className="btn">
                  Sponsor the Event
                </Link>
                {brochure.map((item) => (
                  <a
                    key={item.id}
                    href={item?.attach_file}
                    target="_blank"
                    rel="noreferrer"
                    className="btn btn2"
                  >
                    Download Brochure
                  </a>
                ))}
              </div>
            </div>

            {/* Right — Glass Countdown Card */}
            <div className="col-lg-5" data-aos="fade-left" data-aos-delay="500">
              <div className="hero-glass-card">
                <div className="text-center mb-3">
                  <Countdown />
                </div>
                <EventSwitcher />
                <ul
                  className="list-unstyled m-0 p-0 d-flex align-items-center justify-content-center flex-column gap-3 mt-4"
                  style={{ paddingTop: "20px" }}
                >
                  <li
                    className="d-flex align-items-center gap-3"
                    style={{ color: "#9CA3AF" }}
                  >
                    <i
                      className="fa fa-calendar-o"
                      style={{ color: "#E91E8C", width: "18px" }}
                    />
                    <span>Schedule: {EVENT_DATES}</span>
                  </li>
                  <li
                    className="d-flex align-items-center gap-3"
                    style={{ color: "#9CA3AF" }}
                  >
                    <i
                      className="fa fa-map-marker"
                      style={{ color: "#E91E8C", width: "18px" }}
                    />
                    <span>{EVENT_LOCATION}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/*-- Hero Section end --*/}

      {/*--Overview Section start--*/}
      <section className="overview pb-0">
        <div className="container">
          <div className="inner-overview pb-10 position-relative border-dashed-bottom-2">
            <div className="row">
              {/* Left Text Content */}
              <div className="col-lg-6">
                <div className="overview-left text-center text-lg-start">
                  <div className="overview-title pb-4">
                    <p
                      className="mb-1 pink"
                      data-aos="fade-up"
                      data-aos-delay="800"
                    >
                      OVERVIEW
                    </p>
                    <h2
                      className="mb-2"
                      data-aos="fade-right"
                      data-aos-delay="900"
                    >
                      GET THE LATEST INFO ABOUT{" "}
                      <span
                        className="pink"
                        data-aos="fade-right"
                        data-aos-delay="1000"
                      >
                        <b>PROFINEXPO BANGKOK 2026</b>
                      </span>
                    </h2>
                    <p data-aos="fade-right" data-aos-delay="1100">
                      <b>PROFINEXPO BANGKOK 2026</b> is a premier international
                      financial gathering that brings together global leaders
                      from Forex, FinTech, Blockchain, and digital finance under
                      one roof.
                    </p>
                    <p
                      className="mb-2"
                      data-aos="fade-right"
                      data-aos-delay="1200"
                    >
                      The expo features expert-led discussions, live
                      exhibition booths, continuous networking opportunities,
                      and a prestigious awards ceremony recognizing excellence
                      across the global financial ecosystem.
                    </p>
                  </div>

                  {/* Event Info Boxes */}
                  <div className="overview-event-info pb-6 g-4 text-start position-absolute">
                    <div className="row justify-content-around">
                      {/* Where */}
                      <div className="col-lg-6 col-md-6">
                        <div
                          className="event-info-box align-items-center d-flex p-4 rounded bg-white box-shadow my-2"
                          data-aos="fade-right"
                          data-aos-delay="1300"
                        >
                          <div className="event-info-icon text-center">
                            <i className="fa fa-map-marker text-white bg-pink rounded-circle me-3"></i>
                          </div>
                          <div className="location-info">
                            <Link to="/Contact">
                              <h5 className="mb-1">WHERE</h5>
                              <small className="pink">{EVENT_LOCATION}</small>
                            </Link>
                          </div>
                        </div>
                      </div>

                      {/* When */}
                      <div className="col-lg-6 col-md-6">
                        <div
                          className="event-info-box align-items-center d-flex p-4 rounded bg-white box-shadow my-2"
                          data-aos="fade-left"
                          data-aos-delay="1400"
                        >
                          <div className="event-info-icon text-center">
                            <i className="fa fa-calendar-o text-white bg-pink rounded-circle me-3"></i>
                          </div>
                          <div className="time-info">
                            <Link to="/Contact">
                              <h5 className="mb-1">WHEN</h5>
                              <small className="pink">{EVENT_DATES}</small>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Right Images */}
              <div className="col-lg-6">
                <div className="overview-img">
                  <div className="row align-items-center">
                    <div className="col-lg-6 col-md-6 p-0">
                      <div className="container-img-left mb-2">
                        <div
                          className="img-left-1 float-end w-lg-80"
                          data-aos="zoom-in"
                          data-aos-delay="1000"
                        >
                          <img
                            className="mb-2 w-100 rounded"
                            src={process.env.PUBLIC_URL + "/assets/images/group/1.jpg"}
                            alt="blockchain-session"
                          />
                        </div>
                        <div
                          className="img-left-2"
                          data-aos="zoom-in"
                          data-aos-delay="1200"
                        >
                          <img
                            src={process.env.PUBLIC_URL + "/assets/images/group/2.jpg"}
                            alt="networking"
                            className="w-100 rounded"
                          />
                        </div>
                      </div>
                    </div>

                    <div
                      className="col-lg-6 col-md-6"
                      data-aos="zoom-in"
                      data-aos-delay="1400"
                    >
                      <div className="container-img-right w-lg-75">
                        <img
                          src={process.env.PUBLIC_URL + "/assets/images/group/3.jpg"}
                          alt="expo-floor"
                          className="w-100 rounded"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/*--Overview Section end--*/}

      <EventFeatures />

      <LivePulse />

      <RoleTabs />

      {/*--Partners Section start--*/}
      <TrustedPartners />
      <SponsorPartners />
      <Speakersection />
      <MediaPartners />
      <EventPartners />
      {/*--Partners Section end--*/}

      {/*--Features Section start--*/}
      <section className=" text-white position-relative z-0 start-0">
        <div className="overlay z-n1"></div>
        <div className="container">
          <div className="feature-inner">
            <div className="feature-lists pt-8">
              <div className="row g-4">
                <div className="col-lg-4 col-md-6">
                  <div className="feature-box py-7 h-100 px-6 rounded text bg-black bg-opacity-25">
                    <a>
                      <div className="feature-box-icon mb-4">
                        <i className="fa fa-address-book-o text-white bg-pink rounded-circle text-center"></i>
                      </div>
                      <div className="feature-box-info">
                        <h5 className="text-white mb-2">LIVE STREAMING</h5>
                        <small>
                          Access real-time sessions from global finance,
                          trading, and FinTech experts. Stream keynotes, panels,
                          and workshops from anywhere, ensuring you never miss
                          critical insights.
                        </small>
                      </div>
                    </a>
                  </div>
                </div>

                <div className="col-lg-4 col-md-6">
                  <div className="feature-box py-7 h-100 px-6 rounded bg-black bg-opacity-25">
                    <a>
                      <div className="feature-box-icon mb-4">
                        <i className="fa fa-comments text-white bg-pink rounded-circle text-center"></i>
                      </div>
                      <div className="feature-box-info">
                        <h5 className="text-white mb-2">FIRESIDE CHATS</h5>
                        <small>
                          Engage in intimate discussions with global finance
                          leaders, CEOs, and innovators. Gain actionable advice
                          on trading, investment strategies, and technology
                          adoption in a relaxed, interactive setting.
                        </small>
                      </div>
                    </a>
                  </div>
                </div>

                <div className="col-lg-4 col-md-6">
                  <div className="feature-box py-7 h-100 px-6 rounded bg-black bg-opacity-25">
                    <a>
                      <div className="feature-box-icon mb-4">
                        <i className="fa fa-desktop text-white bg-pink rounded-circle text-center"></i>
                      </div>
                      <div className="feature-box-info">
                        <h5 className="text-white mb-2">NETWORKING</h5>
                        <small>
                          Connect with 5,000+ finance professionals, innovators,
                          investors, and company representatives in dedicated
                          networking areas to foster partnerships and business
                          growth.
                        </small>
                      </div>
                    </a>
                  </div>
                </div>

                <div className="col-lg-4 col-md-6">
                  <div className="feature-box py-7 h-100 px-6 rounded bg-black bg-opacity-25">
                    <a>
                      <div className="feature-box-icon mb-4">
                        <i className="fa fa-cogs text-white bg-pink rounded-circle text-center"></i>
                      </div>
                      <div className="feature-box-info">
                        <h5 className="text-white mb-2">HIGH-VALUE LEARNING</h5>
                        <small>
                          Participate in in-depth workshops, masterclasses, and
                          panel discussions delivered by 30+ industry leaders to
                          sharpen your skills and knowledge in finance, trading,
                          and technology.
                        </small>
                      </div>
                    </a>
                  </div>
                </div>

                <div className="col-lg-4 col-md-6">
                  <div className="feature-box py-7 h-100 px-6 rounded bg-black bg-opacity-25">
                    <a>
                      <div className="feature-box-icon mb-4">
                        <i className="fa fa-gift text-white bg-pink rounded-circle text-center"></i>
                      </div>
                      <div className="feature-box-info">
                        <h5 className="text-white mb-2">EXCITING GIVEAWAYS</h5>
                        <small>
                          Participate in live draws and competitions to win
                          exclusive prizes, branded merchandise, and special
                          recognition at
                          <b>PROFINEXPO BANGKOK 2026</b>.
                        </small>
                      </div>
                    </a>
                  </div>
                </div>

                <div className="col-lg-4 col-md-6">
                  <div className="feature-box py-7 h-100 px-6 rounded bg-black bg-opacity-25">
                    <a>
                      <div className="feature-box-icon mb-4">
                        <i className="fa fa-graduation-cap text-white bg-pink rounded-circle text-center"></i>
                      </div>
                      <div className="feature-box-info">
                        <h5 className="text-white mb-2">1-ON-1 SESSIONS</h5>
                        <small>
                          Schedule personalized meetings with investors,
                          industry experts, and regulators to gain tailored
                          guidance and accelerate your business strategy.
                        </small>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/*--Features Section end--*/}

      {/*--Speakers Section Start--*/}
      {/* <Speakersection /> */}
      {/*--Speakers Section end--*/}

      {/*--Ticketbook Section start--*/}
      <LetsDoIt />
      {/*--Ticketbook Section end--*/}

      {/*--Schedules Section start--*/}
      <SchedulesSection />
      {/*--Schedules Section end--*/}

      {/*--Pricing Section start--*/}
      {/* <TicketSection /> */}
      {/*--Pricing Section end--*/}

      {/* Floorplan Component */}
      <FloorPlanSection id="floorplan" />
      {/* Floorplan Component */}

      {/*--Gallery Section end--*/}
      <section className="gallery">
        <div className="container">
          <div className="galler-inner">
            <div className="section-title text-center mb-5">
              <div className="row align-items-center ">
                <div className="col-lg-6 pb-2">
                  <div className="title-content  text-lg-start">
                    <p className="mb-1 pink">OUR RECENT EVENT GALLERY</p>
                    <h2 className="mb-1">
                      WAS AN AMAZING <span className="pink">GALLERY</span>
                    </h2>
                    <p className="m-0">
                      Our expo in Dubai named ProFX Expo Dubai, where we
                      had an official Guinness World Record! Top traders battled
                      it out for a share of the $25,000 prize pool. A truly
                      unforgettable milestone!
                    </p>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="speaker-button text-lg-end">
                    <Link to="/Ourgallery" className="btn">
                      VIEW MORE SHOTS
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <Gallery limit={6} />
          </div>
        </div>
      </section>
      {/*--Gallery Section end--*/}

      {/*--Testimonials Section start--*/}
      <section className="testimonial bg-lightgrey">
        <div className="container">
          <div className="section-title w-lg-60 m-auto text-center pb-5">
            <p className="mb-1  pink">OUR TESTIMONIALS</p>
            <h2 className="mb-1">
              WHAT PEOPLES'S SAYS ABOUT{" "}
              <span className="pink">PROFINEXPO BANGKOK</span>
            </h2>
            <p className="m-0">
              Powerful Testimonials From Our Delegates And Speakers
            </p>
          </div>
          <TestimonialSlider />
        </div>
      </section>
      {/*--Testimonials Section end--*/}

      {/*--FAQ Section start--*/}
      <FaqSection />
      {/*--FAQ Section end--*/}

      {/*--Direction Section start--*/}
      <DirectionSection />
      {/*--Direction Section end--*/}

      {/*--Blog Section start--*/}
      {/* <BlogSection /> */}
      {/*--Blog Section end--*/}
    </div>
  );
}

export default Home;

